import type { PhotoCanvasUrlFields } from './types/photo-canvas-url-fields'

function firstNonEmpty(...candidates: Array<string | null | undefined>): string {
  for (const value of candidates) {
    if (typeof value === 'string' && value.length > 0) return value
  }

  return ''
}

/**
 * Best URL for drawing a photo on the spread — matches legacy `content.src = urlScr`.
 * Falls back through preview → primary → square crop when a higher-res asset is missing.
 */
export function resolveCanvasPhotoUrl(photo: PhotoCanvasUrlFields): string {
  return firstNonEmpty(photo.urlScr, photo.urlPreview, photo.urlPri, photo.urlSqCrop)
}

/** True when a screen/preview/primary asset is present (not only the tray square crop). */
export function hasPreferredCanvasPhotoUrl(photo: PhotoCanvasUrlFields): boolean {
  return Boolean(firstNonEmpty(photo.urlScr, photo.urlPreview, photo.urlPri))
}

/** Merge candid-detail URL (+ optional pixel) fields onto a tray photo for canvas placement. */
export function mergeCandidDetailIntoPhoto<T extends PhotoCanvasUrlFields>(
  photo: T,
  detail: PhotoCanvasUrlFields & { pixelWidth?: number; pixelHeight?: number }
): T {
  return {
    ...photo,
    ...(detail.urlScr ? { urlScr: detail.urlScr } : {}),
    ...(detail.urlPreview ? { urlPreview: detail.urlPreview } : {}),
    ...(detail.urlPri ? { urlPri: detail.urlPri } : {}),
    ...(detail.pixelWidth && detail.pixelWidth > 0 ? { pixelWidth: detail.pixelWidth } : {}),
    ...(detail.pixelHeight && detail.pixelHeight > 0 ? { pixelHeight: detail.pixelHeight } : {}),
  }
}
